import { PayloadAction } from "@reduxjs/toolkit";
import translations from "constants/translations.json";

export type FilterKeyTypes = keyof typeof translations.en.Categories;
type FileCategoryKeyTypes = keyof typeof translations.en.FileCategories;

// State definition
export type FilterState = {
  active: FilterType[];
  [FilterType.categories]: ColorToggleItem[];
  [FilterType.subcategories]: ColorToggleItem[];
  [FilterType.locations]: ColorToggleItem[];
  [FilterType.providers]: ColorToggleItem[];
  [FilterType.fileTypes]: ColorToggleItem[];
  [FilterType.messageCount]: ColorToggleItem[];
  selection: TimelineRangeType;
  contactFilterRange: { min: number; max: number };
};

export type TimelineRangeType = [Date | undefined, Date | undefined];

// Action types definition
export enum FilterActionTypes {
  SET_ACTIVE_FILTERS = "@@categories/SET_ACTIVE_FILTERS",
  TOGGLE_ITEM = "@@categories/TOGGLE_ITEM",
  UPDATE_COLOR = "@@categories/UPDATE_COLOR",
  UPDATE_SUBCATEGORY = "@@categories/UPDATE_SUBCATEGORY",
  SELECT_ALL = "@@categories/SELECT_ALL",
  DESELECT_ALL = "@@categories/DESELECT_ALL",
  SET_TIMELINESELECTION = "@@categories/SET_TIMELINESELECTION",
  UPDATE_CONTACT = "@@categories/UPDATE_CONTACT",
}

export type ColorToggleItem = {
  id: string;
  key: FilterKeyTypes | FileCategoryKeyTypes;
  label: string;
  value: boolean;
  amount: number;
};

export enum FilterType {
  categories = "categories",
  subcategories = "subcategories",
  locations = "locations",
  providers = "providers",
  fileTypes = "fileTypes",
  messageCount = "messageCount",
}

type SetActiveFiltersAction = PayloadAction<{ active: FilterType[] }, FilterActionTypes.SET_ACTIVE_FILTERS>;
type SetTimelineSelection = PayloadAction<{ selection: TimelineRangeType }, FilterActionTypes.SET_TIMELINESELECTION>;
type ToggleItemAction = PayloadAction<{ filter: FilterType; id: string }, FilterActionTypes.TOGGLE_ITEM>;
type UpdateColorAction = PayloadAction<
  { filter: FilterType; array: [string, string][] },
  FilterActionTypes.UPDATE_COLOR
>;
type CreateSubcatsAction = PayloadAction<{ filter: FilterType }, FilterActionTypes.UPDATE_SUBCATEGORY>;
type SelectAllAction = PayloadAction<{ filter: FilterType }, FilterActionTypes.SELECT_ALL>;
type DeselectAllAction = PayloadAction<{ filter: FilterType }, FilterActionTypes.DESELECT_ALL>;
type UpdateContacts = PayloadAction<{ range: { min: number; max: number } }, FilterActionTypes.UPDATE_CONTACT>;

export type FilterActions =
  | ToggleItemAction
  | UpdateColorAction
  | CreateSubcatsAction
  | SelectAllAction
  | DeselectAllAction
  | SetTimelineSelection
  | SetActiveFiltersAction
  | UpdateContacts;
